import axios from "axios"
import library from "../../../utils/Library"

export const getFirmsCustomerByCuitCorpEntities = async (cuitCliente) => {
    const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl("firmsCustomers") +
    `/getFirmsCustomerByCuitCorpEntities?customerSuborganizationCuit=${cuitCliente}`

  return await axios.get(URL, {
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
